module.exports = "/assets/c857a79967600008ffe24009f7468756.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/MT.png
// module id = 1626
// module chunks = 0